var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "50.7998mm",
    height: "50.7998mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5080 5080",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   .fil0 {fill:#2255A1}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M5080 2534c0,-1400 -1134,-2534 -2546,-2534 -798,0 -1504,370 -1967,949l486 127c46,12 93,58 104,104l0 0 104 382c24,81 -23,174 -115,197 -81,23 -162,-35 -197,-116l-70 -289 -509 -127c-231,381 -370,833 -370,1307 0,1412 1134,2546 2534,2546 1412,0 2546,-1134 2546,-2546zm-3668 764c-23,-70 23,-162 104,-185 93,-23 174,23 197,104l11 23 1389 150 150 -462 -1839 0c-70,0 -139,-47 -151,-116l-197 -764c-23,-81 23,-162 116,-185 0,0 12,0 12,0l0 0 2511 -417c81,-11 173,47 173,128 12,34 12,58 0,81l-115 439c-24,82 -116,128 -197,105 -93,-23 -128,-105 -116,-186l58 -219 -2095 347 116 474 1921 0c23,0 35,0 58,12 81,23 127,104 104,196l-243 787c-12,70 -81,116 -162,104l-1632 -173c-69,0 -115,-46 -139,-116l-34 -127 0 0zm1666 752c0,-127 -104,-231 -231,-231 -128,0 -232,104 -232,231 0,127 104,243 232,243 127,0 231,-116 231,-243zm-972 -104c0,-139 -104,-243 -231,-243 -139,0 -243,104 -243,243 0,127 104,231 243,231 127,0 231,-104 231,-231z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainCircleIcon);
export default __webpack_public_path__ + "static/media/main-circle-icon.8c5fee1646a4baa45af04d303fd0e6ae.svg";
export { ForwardRef as ReactComponent };